import { useEffect } from "react";
import Farmer from '../table/Tablefarmer';
import Modal from "../modal/Modaladdfarmer"
import Modalfarmer from "../modal/Importfarmer"



const Dashboard = () => {
  useEffect(() => {
    // getPromise(["sales", "purchases"]);
  }, []);


  return (
    <>
    <div style={{display:"flex"}}>
      <Modal/>
    <Modalfarmer style={{marginLeft:"10px"}}/>
    </div>
    
    <Farmer/>
    
     
     </>
  );
};

export default Dashboard;
